export enum ClientPlatform {
  DesktopWeb = 1,
  MobileWeb = 2,
  MobileApp = 3,
}
